import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { faAward } from '@fortawesome/pro-thin-svg-icons';

import '../styles/ProgrammeCompleted.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import FocusLock from 'react-focus-lock';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import completeImg from '../images/complete.png';
import { Confetti } from './Confetti';

export function ProgrammeCompleted(props) {
  const { t } = useTranslation();
  const [confettiActive, setConfettiActive] = useState(true);

  const textArr = t('M073').split('!');
  textArr[0] += '!';

  useEffect(() => {
    setConfettiActive(true);
    setTimeout(() => {
      setConfettiActive(false);
    }, 10000);
  }, []);

  return (
    <FocusLock returnFocus>
      <div className="popup-overlay" role="dialog" aria-modal="true">
        <span className="sr-only">{t('modal.programme.completed')}</span>
        {confettiActive && <Confetti isActive={confettiActive} />}
        <div className="dark-container">
          <FontAwesomeIcon icon={faAward} className="icon award" />
          <img src={completeImg} alt="`Complete` in large colourful font" />

          {textArr.map((item, index) => (
            // Segments of one split i18n string, static and possibly duplicated.
            // eslint-disable-next-line react/no-array-index-key
            <h1 key={index}>{item}</h1>
          ))}

          <Button
            onClick={props.closeProgrammeCompleted}
            color="white"
            icon={{ faIconDefinition: faArrowRight, size: 'lg' }}
          >
            {t('M012')}
          </Button>
        </div>
      </div>
    </FocusLock>
  );
}
